import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-edge bg-boneAlt mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <h3 className="font-serif text-3xl">
            <span className="text-olive">OliveOil</span><span className="text-ink-muted/70 font-normal">.shop</span>
          </h3>
          <p className="overline mt-2">{t("footer.tagline")}</p>
          <p className="text-sm text-ink-soft mt-6 max-w-md leading-relaxed">
            {t("footer.blurb")}
          </p>
        </div>
        <div>
          <p className="overline mb-4">{t("footer.shop")}</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop?type=extra_virgin" className="hover:text-olive">{t("footer.extraVirgin")}</Link></li>
            <li><Link to="/shop?type=flavored" className="hover:text-olive">{t("footer.flavoredOils")}</Link></li>
            <li><Link to="/shop?organic=true" className="hover:text-olive">{t("footer.certifiedOrganic")}</Link></li>
            <li><Link to="/vendors" className="hover:text-olive">{t("footer.allProducers")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline mb-4">{t("footer.marketplace")}</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/become-vendor" className="hover:text-olive">{t("footer.sellOnOlivara")}</Link></li>
            <li><Link to="/login" className="hover:text-olive">{t("footer.signIn")}</Link></li>
            <li><Link to="/register" className="hover:text-olive">{t("footer.createAccount")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-edge">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center text-xs text-ink-muted">
          <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
          <p className="font-serif italic mt-2 sm:mt-0">{t("footer.quote")}</p>
        </div>
      </div>
    </footer>
  );
};
